"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_country__international(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9c2e0e9f-211f-4cc4-bd77-d5fd92bc4110",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96.29,
    r: 80,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "country-or-international-hi"), /*#__PURE__*/React.createElement("g", {
    id: "7690a888-a953-4c18-90a6-078c27047729",
    "data-name": "country-or-international-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7600145a-dc98-48cd-b16b-d6aacb12e88d",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ab2d9e64-5346-4717-a7a7-b81e1923757c",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2848faff-07d0-4a30-ab75-3486edb65611",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6a445b82-0f39-49c6-952b-5052507d48b6",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bbbda0d9-43f6-4e3a-b2a9-aab0cab14a7d",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2260f5b-54ef-448b-98a4-48d8b091971a",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "33027ef7-f9b9-44f4-9c54-4929e154d4a1",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "63292625-8ce3-4b15-a6d4-97bda68c4ab0",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8f43c8fe-5c2e-454c-a748-f9a9c73969cd",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b9c64ee2-dc51-4740-9742-922f2298fa4a",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ac0cb144-bb3d-49a0-a1b0-df976415b978",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5eaae723-3561-41f1-8877-2fbc81058373",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "30ae6e13-3b5a-4d0b-94f0-8cfc6a28d37c",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16dcbc22-4577-4623-99f4-30536e63b047",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "505b43a0-5e56-4ce2-84ee-f90e56e88757",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "920fd6f4-791e-4ad4-a486-1f285ef30925",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9295e9e1-356f-452d-9365-ee1e5b4b3cb3",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "76e9833c-d227-4d49-99e9-43dd20d93376",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "78537505-4634-486f-9c67-145fb6772af1",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f5884b68-843a-4c26-a5ac-e7e9d0e1f119",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "94b210b0-b45b-4b2f-931b-4fc09f6f0783",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3cff7fa2-c040-41b8-b0c6-1280087f63c4",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3704fd4e-16ee-40d9-9781-d5d9b351df8d",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9041efc7-570c-4ca5-a3ab-02085862a962",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "911f1909-0492-416b-91c1-29218417bd55",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a5054cca-8226-40e3-be6f-a04052387b7b",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7782ca21-08af-4597-aced-971915e50c1d",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96.29,
    r: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174.29a80,80,0,0,0,80-79c0,.33,0,.66,0,1a80,80,0,1,1-160,0c0-.34,0-.67,0-1A80,80,0,0,0,96,174.29Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c2e0e9f-211f-4cc4-bd77-d5fd92bc4110)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,55.29c0,11.6,31.34,21,70,21s70-9.4,70-21",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,23.79c0,5.8,15.67,10.5,35,10.5s35-4.7,35-10.5",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,139.29c0,11.6,31.34,21,70,21s70-9.4,70-21",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "6193abe2-8c73-4ae5-9ff3-331ec861b63b",
    "data-name": "<Pfad>",
    d: "M90.65,12.71C65.57,34.23,47.75,63.28,47.75,95.5c0,31.78,18.27,61.38,42.9,82.79",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "fe129f44-3169-4fc0-9398-739b5e4669c3",
    "data-name": "<Pfad>",
    d: "M104.72,12.71c25.08,21.52,42.9,50.57,42.9,82.79,0,31.78-18.27,61.38-42.9,82.79",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "37119986-ce52-41ec-b7ae-408deecc51ca",
    "data-name": "<Pfad>",
    x1: 97.68,
    y1: 178.29,
    x2: 97.68,
    y2: 14.41,
    opacity: 0.06,
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,97.29c0,13.92,37.61,25.2,84,25.2s84-11.28,84-25.2",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    transform: "translate(192 192) rotate(-180)",
    fill: "none"
  }))))))))))))))))))))))))))))));
}

var _default = ic_country__international;
exports.default = _default;